import * as React from 'react';

import { Button } from 'src/registry/ui/Button';
import { Calendar } from 'src/registry/ui/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from 'src/registry/ui/Popover';
import { cn } from 'src/utils/shadcn';

interface SingleDatePickerProps extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onSelect' | 'onChange'> {
    value?: Date;
    buttonValue: string;
    onChange: (date: Date | undefined) => void;
    className?: string;
}

const SingleDatePicker = ({ onChange, value, buttonValue, className }: SingleDatePickerProps) => {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button id="date" variant="outline" className={cn('justify-center p-2 text-sm font-normal', className)}>
                    {buttonValue}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start" side="bottom" portal={false}>
                <Calendar
                    mode="single"
                    onSelect={onChange}
                    onDayClick={onChange}
                    timeZone="UTC"
                    selected={value}
                    defaultMonth={value}
                    required={false}
                />
            </PopoverContent>
        </Popover>
    );
};

export default SingleDatePicker;
